import type { CrmPatientSummary } from "../types";

/**
 * Lookup do extrato: Patient por id e Patient/{id}; Person só em Person/{id}
 * (Patient vence se o id coincidir).
 */
export function buildExtractRecipientLookup(
  patientLookup: Map<string, CrmPatientSummary>,
  personSummaries: CrmPatientSummary[],
): Map<string, CrmPatientSummary> {
  const merged = new Map(patientLookup);

  for (const [id, summary] of patientLookup) {
    if (id.startsWith("Patient/") || id.startsWith("Person/")) continue;
    merged.set(`Patient/${id}`, summary);
  }

  for (const person of personSummaries) {
    const personId = person.patientId?.trim();
    if (!personId) continue;
    merged.set(`Person/${personId}`, person);
    if (!merged.has(personId)) {
      merged.set(personId, person);
    }
  }

  return merged;
}
